<template>
    <div class="upload-file-custom">
        <div
            v-show="preView && !disabled"
            class="file"
        >
            <label class="file-box" :class="disabled? 'disabled-btn' : ''">
                <span class="btn">{{ texts }}</span>
                <input
                    ref="filey"
                    type="file"
                    @change="hanleFileChange"
                >
            </label>
            <label :title="fileName" class="file-name">{{ cfileName }}</label>
            <label
                v-if="cfileName"
                class="file-del"
                @click="handleDelete"
            >删除</label>
        </div>
        <span
            v-if="value && disabled"
            class="download-btn"
            @click="handleDownload"
        >下载</span>
        <el-button
            ref="uploadfile_btn"
            slot="trigger"
            size="small"
            :class="['uploadfile_btn',preView ? 'hidden_btn':'']"
            @click="putBlob"
        >
            上传
        </el-button>
        <el-progress
            v-if="progressShow"
            :percentage="progress"
            class="upload_progress"
        />
    </div>
</template>

<script>
const MIME = {
  DOC: "application/msword",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  PDF: "application/pdf",
  PPT: "application/vnd.ms-powerpoint",
  PPTX: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  XLS1: "application/vnd.ms-excel",
  XLS2: "application/x-excel",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  JPG:  "image/jpg",
  JPEG: "image/jpeg",
  PNG:  "image/png",
  GIF:  "image/gif"
};



export default {
  props: {
    value:{
      type:Object | String,
      default: null
    },

    texts:{
      type: String,
      default: "选择附件"
    },

    disabled: {
      type: Boolean,
      default: false
    },

    preView: {
      type: Boolean,
      default: true
    },

    progressShow: {
      type: Boolean,
      default: false
    },

    filePath: {
      type: String,
      default: ""
    },

    fileTypes: {
      type: Array,
      default: () => ([])
    },

    fileSize: {
      type: Number,
      default: 200
    },

    /* 是否支持预览 */
    isPreView: {
      type: Boolean,
      default: true
    },

    isSelectedUpload: {
      type: Boolean,
      default: false
    },

    defalut: {
      type: Boolean,
      default: true
    }

  },

  data() {
    return {
      progress: 0,
      uploaddata: "",
      file: {},
      fileName: "",
      cfileName: "",

      fileTypeList: []
    };
  },

  computed:{
    _value:{
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
        this.$emit("input", val);

        let parent = this.$parent || this.$root;
        let name = parent.$options.componentName;

        while (parent && (!name || name !== "ElFormItem")) {
          parent = parent.$parent;

          if (parent) {
            name = parent.$options.componentName;
          }
        }

        if (parent) {
          parent.$emit.apply(parent, ["el.form.change"].concat([val]));
        }
      }
    }
  },

  watch: {
    fileTypes(val) {
      val.map(item => {
        this.fileTypeList.push(MIME[item]);
        return item;
      });
    },

    defalut: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          const ds=this.$refs.filey;
          ds.value ="";
          ds.form[0].value="";
          ds.form[1].value="";
          this.fileName = "";
          this.$emit("changefile", false);
        }
      }
    },

    fileName(val) {
      let len = val.length;
      let type = val.slice(val.indexOf("."),len);
      if (val === "" || val === null || val === undefined) {
        this.cfileName = "";
      }
      this.cfileName = val;
    }
  },
  created() {
    if (this.fileTypes.length) {
      this.fileTypes.map(item => {
        this.fileTypeList.push(MIME[item]);
        return item;
      });
    }
  },
  methods: {
    handleDownload() {
      window.open(this.value);
    },
    hanleFileChange(e) {
      if (this.disabled) {
        return;
      }
      const files = Array.from(e.target.files);
      this.fileName = files[0].name;
      this.file = files[0];

      this._value = {
        file: this.file,
        name: this.fileName,
        url: "",
        filePath: this.filePath,
        fileSize: this.file.size,
        fileType: this.file.type
      };
      if (this.isSelectedUpload) {
        this.putBlob();
      }
    },

    reset() {
      this.fileName = "";
      this.file = {};
    },

    handleDelete() {
      this.fileName = "";
      this.file = {};

      this._value = {
        name: this.fileName,
        url: "",
        filePath: "",
        fileSize: this.file.size,
        fileType: this.file.type
      };
      const ds=this.$refs.filey;
      ds.value ="";
      this.fileName = "";
    },

    async putBlob() {
      let filed = this.file;
      // let OSS = require("ali-oss");
      let date = new Date().getTime();
      // let ossname='boss/' + date+filed.name;

      let size = filed.size / 1024 / 1024;
      let type = filed.type;
      //格式限制

      if (this.fileTypeList.includes(type)) {
        //大小限制
        if (size > this.fileSize) {
          this.$message({
            message: `上传的文件大小不能超过${this.fileSize}M`,
            type: "warning"
          });
        } else {
          //oss参数
          let data = await this.$axios.post("/api/attach/auth"); //授权

          let name = filed.name;
          let _name = data.fileName + name.substring(name.lastIndexOf("."),name.length);

          let storeAs = `${this.filePath}${date}/${_name}`;
          //阿里请求
          // let client = new OSS({
          //   endpoint: data.region,
          //   accessKeyId: data.accessKeyId,
          //   accessKeySecret: data.accessKeySecret,
          //   stsToken: data.securityToken,
          //   bucket: data.bucket
          // });

          // let _this = this;
          // client.multipartUpload(storeAs, filed, {
          //   progress: function (p) {
          //     //进度条
          //     _this.progress = Math.floor(p * 100);
          //   },
          //   mime: this.isPreView ? "" : "application/octet-stream",
          //   secure:true
          // }).then(function (result) {
          //   let url=result.res.requestUrls[0];
          //   let new_url="";
          //   // console.log(url);
          //   if (url.indexOf("?") > 0) {
          //     new_url = url.substring(0, url.indexOf("?"));
          //   } else {
          //     new_url = url;
          //   }

          //   let data = {
          //     file: filed,
          //     name: filed.name,
          //     url: new_url,
          //     filePath: storeAs,
          //     fileSize: filed.size
          //   };

          //   _this.$emit("uploaddata", data);

          // }).catch(function (err) {

          //   console.log(err);
          //   _this.$message.error("授权失效，请重新授权！");

          // });
        }
      } else {
        const file = this.fileTypes.join();
        this.$message({
          message: `上传的文件格式仅支持${file}`,
          type: "warning"
        });
      }
      // this.fileName="";
    }
  }
};
</script>

<style lang="scss">
    .upload-file-custom{
      width: 100%;

      .download-btn{
        color: #258FF8;
        cursor: pointer;
      }
      .file{
          display: flex;
          // position: relative;
          label{
              display: inline-block;
          }
          &-box{
              display: inline-block;
              border: 1px solid #DADEE6;
              border-radius: 2px;
              overflow: hidden;
              cursor: pointer;
              text-align: center;
              .btn{
                  padding: 7px 23px;
                  line-height: 32px;
                  font-size: 14px;
                  color: #258FF8;
                  text-align: center;
              }
              input {
                position: absolute;
                font-size: 0;
                right: -20px;
                top: -30px;
                opacity: 0;
                width: 0;
                height: 0;
              }
          }
          .disabled-btn{
            cursor: not-allowed;
          }
          &-name{
              flex: 1;
              padding:  0 5px;
              color: #333333;
              text-align: center;
          }
          &-del{
              color: #258FF8;
              padding: 0 5px;
              cursor: pointer;
          }
      }


      .uploadfile_btn{
          width: 50px;
          position: absolute;
          right: 0;
      }
      .upload_btn{
          z-index: 99;
          width: 322px;
          height: 40px;
          cursor: pointer
      }
      .hidden_btn{
          visibility: hidden;
      }
}

</style>
